// extracted by mini-css-extract-plugin
export var controlsBlockContainer = "z2a-ANhr";
export var controlsBlock = "x0iemQUw";
export var title = "bFGuAcjO";
export var formSubmitButton = "_9WaNoozC";
export var hideMobile = "pL4jzov8";
export var description = "h6uhFr4Y";